module.exports = __webpack_public_path__ + "afe7f50d1d6215d8609c68bf2e47a323.png";